import NotFound from "@common/components/shared/not-found"
import { Toaster } from "@common/components/ui/toaster"
import type { QueryClient } from "@tanstack/react-query"
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router"
import { z } from "zod"

// Ubiquitous param: the extension appends from_trace_id when opening the web app
// so the user's trace session can be re-attached here. Declared at the root so it
// is preserved and typed on every route (TanStack merges search down the tree).
const rootSearchSchema = z.object({
  from_trace_id: z.string().optional(),
})

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient
}>()({
  validateSearch: rootSearchSchema,
  component: () => (
    <>
      <Outlet />
      <Toaster />
    </>
  ),
  notFoundComponent: () => <NotFound />,
})
